<template>
  <div class="timeExpired-box">
    <van-list
      v-model:loading="state.loading"
      :finished="state.finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <van-cell
        v-for="(item, i) in state.list"
        :key="i + '-list'"
        :border="false"
      >
        <template #value>
          <div class="game-div" v-if="item.is_split == 0">
            <div id="recycle-info">
              <h3><span>¥</span>{{ item.coupon_money }}</h3>
              <p>满{{ item.pay_money }}元使用</p>
            </div>

            <div class="coupon-item">
              <p>{{ item.coupon_name }}</p>
              <p>适用于{{ item.gamename }}</p>
              <p>有效期至 {{ item.end_time.slice(0, 16) }}</p>
              <img src="../../../assets/coupon/yz_timeover.png" alt="" />
            </div>
          </div>
          <div class="game-div" v-else-if="item.is_split === 1">
            <div id="recycle-info">
              <p class="split">余额</p>
              <h3><span>¥</span>{{ item.coupon_money }}</h3>
            </div>

            <div class="coupon-item">
              <p>
                <span>{{ item.coupon_name }}</span>
                <span>（可拆分使用）</span>
                <img
                  src="../../../assets/coupon/icon_split_tips.png"
                  alt=""
                  @click="openTips"
                />
              </p>
              <p>适用于{{ item.gamename }}</p>
              <p>有效期至 {{ item.end_time.slice(0, 16) }}</p>
              <img src="../../../assets/coupon/yz_timeover.png" alt="" />
            </div>
          </div>
        </template>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
import {
  reactive,
  onBeforeMount,
  onMounted,
  onActivated,
  onDeactivated,
} from "vue";
import { mycoupons } from "@/api/user";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { setToken, getToken, removeToken } from "@/utils/auth";
import { getQueryString } from "@/utils/location";
import bus from "@/utils/bus";
export default {
  name: "timeExpired",
  setup() {
    const router = useRouter();
    const store = useStore();
    const state = reactive({
      list: [],
      loading: false,
      finished: false,
    });
    // 加载数据
    onBeforeMount(() => {
      if (getQueryString("token")) {
        setToken(getQueryString("token"));
        store.dispatch("getInfo");
      }
    });
    var pagecode = 1;
    var totalpage = 1;
    const onLoad = async () => {
      var data = {
        status: 2,
        pagecode: pagecode,
        uid: getQueryString("uid"),
      };
      await mycoupons(data).then((response) => {
        if (response.data.code == 1) {
          if (pagecode > response.data.data.total_page) {
            state.finished = true;
            return;
          }

          totalpage = response.data.data.total_page;
          state.list = state.list.concat(response.data.data.lists);
          // 去除id相同的数据
          var obj = {};
          state.list = state.list.reduce(function(item, next) {
            obj[next.id] ? "" : (obj[next.id] = true && item.push(next));
            return item;
          }, []);
          console.log(state.list);
          if (pagecode > totalpage) {
            state.finished = true;
          }
          pagecode++;
        } else {
          state.finished = true;
        }
      });
      state.loading = false;
    };

    onActivated(() => {
      pagecode = 1;
      state.loading = false;
      state.finished = false;
      // onLoad()
    });
    onDeactivated(() => {
      pagecode = 1;
      state.loading = false;
      state.finished = false;
    });

    const openTips = () => {
      bus.emit("splitShow");
    };

    return {
      state,
      onLoad,
      openTips,
    };
  },
};
</script>

<style scoped="scoped" lang="less">
.timeExpired-box {
  height: 100vh;

  background-color: #f7f8fa;

  .van-cell {
    background-color: #f7f8fa;
    padding: 10px 32px;
  }
  .game-div {
    display: flex;
    margin-top: 10px;
    align-items: center;
    padding-top: 15px;
    padding-bottom: 15px;
    height: 186px;
    width: 686px;
    background: url(../../../assets/coupon/yz_wdyhq_bj2.png) no-repeat center top;
    background-size: 100% 100%;

    #recycle-info {
      width: 176px;
      height: 160px;
      /* padding: 46px 32px 32px 32px; */
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      color: #999999;

      .split {
        font-size: 24px;
      }

      h3 {
        font-size: 40px;

        span {
          font-size: 20px;
        }
      }

      p {
        font-size: 16px;
        color: #999999;
      }
    }

    .coupon-item {
      margin-left: 32px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      p {
        font-size: 20px;
        color: #707070;

        &:nth-of-type(1) {
          font-size: 28px;
          color: #999999;
          font-weight: 500;
          display: flex;
          align-items: center;

          span {
            font-size: 20px;

            &:nth-of-type(1) {
              font-size: 28px;
              max-width: 252px;
              text-wrap: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }

          img {
            width: 24px;
            height: 24px;
            position: relative;
            top: 0;
            right: 0;
            z-index: 99;
          }
        }
      }

      img {
        position: absolute;
        right: 30px;
        top: 35px;
        width: 120px;
        height: 120px;
      }
    }
  }
  ::v-deep .van-list__finished-text {
    background-color: #f7f8fa;
  }
}
</style>
